import React, { Component } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { MediaManagerComponent } from "./MediaManagerComponent";

export default class MediaManagerDialog extends Component {
  render() {
    const { open, onClose, onSelect, typePreSelection } = this.props;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth={false} // disable built-in width constraints
        sx={{ zIndex: 1300 }}
        PaperProps={{
          sx: {
            width: "95vw",
            maxWidth: "1400px",
            height: "90vh",
            overflow: "hidden", // 🔷 disable outer scrolling
          },
        }}
      >
        <DialogTitle sx={{ fontSize: 16 }}>
          Medien auswählen
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            padding: 0,
            overflow: "hidden", // 🔷 also prevent DialogContent scrolling
          }}
        >
          <MediaManagerComponent
            typePreSelection={typePreSelection}
            showAlertDisplay={(msg, severity) => {
              console.log(`[MediaManagerDialog Alert] ${severity}: ${msg}`);
            }}
            onSelect={onSelect}
          />
        </DialogContent>
      </Dialog>
    );
  }
}
